(ns hai.web-app.connectivity
  (:require
   [hai.ui.rf-sugar :refer [>e >e! defeffect defevent defevent-fx defsub]]))

(defsub ::online? [db]
  (get db ::online? true))

(defevent ::set-online? [db online?]
  (assoc db ::online? online?))

(defeffect ::listen [_]
  (.addEventListener js/window "online"  #(>e [::set-online? true]))
  (.addEventListener js/window "offline" #(>e [::set-online? false])))

(defevent-fx ::initialize [_ _]
  {::listen true})

(defn init! []
  (>e! [::initialize]))
